// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDHwNxJ9v2lHVkV3Kw54EtkgwxEou9eUH4",
    authDomain: "agri-vision-gabon-f32c3.firebaseapp.com",
    projectId: "agri-vision-gabon-f32c3",
    storageBucket: "agri-vision-gabon-f32c3.firebasestorage.app",
    messagingSenderId: "812950880210",
    appId: "1:812950880210:web:3cb758d81a572eccff520b",
    measurementId: "G-FVXLS961B4"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
export const auth = getAuth(app);